<template>
  <div>
      <div class="flex w-full justify-between mx-auto">
        <h2 class="text-base text-costeaDarkGray font-medium">Ranking de los productos</h2>
        <button class="flex bg-costeaPrimary text-white py-2 px-4 justify-center items-center rounded-md">Exportar</button>
    </div>

    <div class="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        <RankingCard
            v-for="(ranking, index) in homeContent.rankingHome.cardRankingHome" :key="index"
            :ranking="ranking"
        />
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import RankingCard from '@/components/home/RankingCard.vue'
export default {
    components:{
        RankingCard
    },
    computed:{
        ...mapState(['homeContent']),
    }

}
</script>

<style>
</style>
